module.exports = __webpack_public_path__ + "img/spfc3.81dcc9df.jpg";